import { render, staticRenderFns } from "./form_step.vue?vue&type=template&id=08d07b12&"
import script from "./form_step.vue?vue&type=script&lang=js&"
export * from "./form_step.vue?vue&type=script&lang=js&"
import style0 from "./form_step.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports